import React from "react";
import styled from "styled-components";
import { InnerLayout } from "../styles/Layouts";
import SectionTitle from "./SectionTitle";
import ServiceCard from "./ServiceCard";
import mobile from "../img/about/mobile.png";
import website from "../img/about/website.png";
import backend from "../img/about/backend.png";
import { StaggerContainer, StaggerItem } from "./AnimatedComponents";

const ServicesSection: React.FC = () => {
  return (
    <ServicesSectionStyled>
      <SectionTitle title={"What I Do"} span={"skills"} />
      <InnerLayout>
        <StaggerContainer stagger={0.15}>
          <div className="services-grid">
            <StaggerItem>
              <ServiceCard
                image={website}
                title={"Full Stack Engineering"}
                paragraph={
                  "Build production-grade UIs with React, Angular and TypeScript — from Azure portal experiences and component libraries to full-stack web applications with Next.js and Fluent UI"
                }
              />
            </StaggerItem>
            <StaggerItem>
              <ServiceCard
                image={backend}
                title={"Backend & Cloud Infrastructure"}
                paragraph={
                  "Design REST APIs and cloud services with C#/.NET, Python and Node.js. Build CLI extensions, Terraform modules, and deploy on Azure with Docker and Kubernetes"
                }
              />
            </StaggerItem>
            <StaggerItem>
              <ServiceCard
                image={mobile}
                title={"Research & 3D Systems"}
                paragraph={
                  "Published deep learning research at IEEE ICMLA, VISAPP and ICECET. Build 3D rendering systems with WebGL, DirectX and WPF for simulation and CAD platforms"
                }
              />
            </StaggerItem>
          </div>
        </StaggerContainer>
      </InnerLayout>
    </ServicesSectionStyled>
  );
};

const ServicesSectionStyled = styled.section`
  .services-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 1.5rem;

    @media screen and (max-width: 950px) {
      grid-template-columns: repeat(2, 1fr);
    }

    @media screen and (max-width: 600px) {
      grid-template-columns: 1fr;
    }
  }
`;

export default ServicesSection;
